/* Publishing an approval route (ADR-0067). A form for the one Admin act, and beneath it the routes
   that already exist. Tokens only: stylelint refuses a colour literal (ADR-0007). */

.form {
  display: grid;
  gap: 10px;
}

.fieldRow {
  display: flex;
  flex-wrap: wrap;

  /* The controls share a bottom line whatever their labels do (alignment audit, 2026-11-03). */
  align-items: flex-end;
  gap: 10px 14px;
}

.field {
  display: grid;
  gap: 4px;
  min-width: 0;
  font-size: var(--t-min);
  font-weight: 600;
  color: var(--ink-2);
}

.field input[type="text"],
.field select {
  padding: 6px 8px;
  font: inherit;
  font-size: var(--t-dense);
  font-weight: 400;
  color: var(--ink);
  background: var(--panel);
  border: 1px solid var(--line-2);
  border-radius: 6px;
}

.field input[aria-invalid="true"] {
  border-color: var(--crit);
}

.check {
  display: flex;
  align-items: baseline;
  gap: 6px;
  font-size: var(--t-dense);
  color: var(--ink);
}

.hint {
  font-size: var(--t-min);
  font-weight: 400;
  line-height: 1.45;
  color: var(--muted);
}

/* The stages are an ordered list because their order is their meaning: the server numbers them in
   the order drawn, and a reader should see the number they are about to be given. */
.stages {
  display: grid;
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
  counter-reset: stage;
}

.stage {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 8px 12px;
  padding: 8px 10px;
  border: 1px solid var(--line);
  border-radius: 6px;
  background: var(--panel-2);
}

.stage::before {
  counter-increment: stage;
  content: "Stage " counter(stage);
  align-self: center;
  min-width: 52px;
  font-size: var(--t-min);
  font-weight: 650;
  color: var(--ink-2);
}

.stagesBox {
  display: grid;
  gap: 8px;
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
}

.published {
  margin: 0;
  padding: 8px 10px;
  border: 1px solid var(--accent-line);
  border-radius: 7px;
  background: var(--accent-w);
  font-size: var(--t-dense);
  line-height: 1.5;
  color: var(--ink-2);
}

.routes {
  display: grid;
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.route {
  display: grid;
  gap: 2px;
  padding: 8px 0;
  border-bottom: 1px solid var(--line);
  font-size: var(--t-dense);
  color: var(--ink);
}

.routeHead {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 4px 10px;
  font-weight: 650;
}

.routeMeta {
  font-size: var(--t-min);
  font-weight: 400;
  color: var(--muted);
}

.routeStages {
  margin: 0;
  padding-left: 18px;
  font-size: var(--t-min);
  color: var(--ink-2);
}

.listHead {
  margin: 14px 0 4px;
  font-size: var(--t-min);
  font-weight: 650;
  color: var(--muted);
}
